import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseClass } from 'src/app/@shared/base-class/base-class';
import { IbaseService } from 'src/app/@shared/base-service/ibase-service';
import { WebserviceService } from 'src/app/@shared/services/webservice.service';

@Component({
  selector: 'app-sport-list',
  templateUrl: './sport-list.component.html',
  styleUrls: ['./sport-list.component.css']
})
export class SportListComponent extends BaseClass<any> implements OnInit {

  public data: any;
  @Input() list!: any;
  @Input() viewBy: any = 't';
  @Input() eventId!: any;
  @Input() eventName!: any;
  @Input() oddsData!: any;

  public odds: any;
  public id = '';
  public eId = '';
  public marketsReq: any[] = [];
  public datalength: any = 0;

  constructor(
    public service: WebserviceService,
    public actRoute: ActivatedRoute
  ) { super(document); }

  ngOnInit(): void {
  }

  getServices(): IbaseService<any> {
    return this.service;
  }

  listByTypeId(items: any, id: any) {
    const grouped = this.groupBy(items, (dat: any) => dat.event_type_id);
    let dt = grouped.get(id) ? grouped.get(id) : [];
    return [{ name: '', data: dt }];
  }

  listByinPlay(items: any) {
    let dt = items.filter((s: any) => this.events.sports.includes(s?.event_type_id));
    // return this.genTypeWiseData(dt).sort((a,b) => b.id - a.id);
    return [{ name: '', data: dt}];
  }

  listByTypeIdCat(items: any, id: any) {
    const grouped = this.groupBy(items, (dat: any) => dat.event_type_id);
    let dt = grouped.get(id) ? grouped.get(id) : [];
    return this.genCompetitionWiseData(dt);
  }

  listByinPlayCat(items: any) {
    let dt = items.filter((s: any) => !this.events.races.includes(s?.event_type_id));
    return this.genCompetitionWiseData(dt);
  }

  listByTypeIdData(items: any, id: any) {
    const grouped = this.groupBy(items, (dat: any) => dat.event_type_id);
    return grouped.get(id) ? grouped.get(id) : [];
  }

  listByinPlayData(items: any) {
    return items.filter((s: any) => this.events.sports.includes(s?.event_type_id));
  }

  reArrangeRaceData(items: any, id: any) {
    items = this.listByTypeIdData(items, id);

    let rc = items.map((a: any) => (a.event_country_code));
    const uniqueSet1 = new Set(rc);
    rc = [...uniqueSet1];
    rc = rc.map((a: any) => ({ race: '', event_country_code: a, data: [] }));
    const grouped = this.groupBy(items, (dat: any) => dat.event_country_code);

    rc.forEach((element: any) => {
      let dt = grouped.get(element.event_country_code) ? grouped.get(element.event_country_code) : [];
      let rcd = dt.map((a: any) => (a.event_id));
      const uniqueSet1 = new Set(rcd);
      rcd = [...uniqueSet1];
      rcd = rcd.map((a: any) => ({ event_id: a, event_name: '', data: [] }));
      const groupedByEvent = this.groupBy(dt, (dat: any) => dat.event_id);

      rcd.forEach((eEle: any) => {
        eEle.data = [...eEle.data, ...groupedByEvent.get(eEle.event_id) ? groupedByEvent.get(eEle.event_id) : []]
        eEle.event_name = eEle.data[0]?.event_name;
      });

      element.data = rcd
    });

    return rc;
  }

  genCompetitionWiseData(e: any) {
    let dataByCat: any[] = [];
    if (e.length > 0) {
      let ids: any[] = [];
      e.forEach((tdt: any) => {
        ids.push({ id: tdt.competition_id, name: tdt.competition_name });
      });
      ids = [... new Set(ids.map(JSON.stringify as any))].map(JSON.parse as any)
      const grouped = this.groupBy(e, (dat: any) => dat.competition_id);
      ids.forEach((ele) => {
        if (grouped.get(ele.id)) {
          let eventTypeIds = grouped.get(ele.id).map((emp: any) => { return emp.event_type_id });
          dataByCat.push({ name: ele.name, data: grouped.get(ele.id), eTypeIds: eventTypeIds })
        }
      });
    }
    return dataByCat;
  }

  genTypeWiseData(e: any) {
    let ids: any[] = [];
    if (e.length > 0) {
      e.forEach((tdt: any) => {
        ids.push({ id: tdt.event_type_id });
      });
      ids = [... new Set(ids.map(JSON.stringify as any))].map(JSON.parse as any)
      ids.forEach((ele) => {
        // if (grouped.get(ele.id)) {
        ele['data'] = this.listByTypeId(e, ele.id)
        // let eventTypeIds = grouped.get(ele.id).map((emp: any) => { return emp.event_type_id });
        // dataByCat.push({ name: ele.name, data: grouped.get(ele.id), eTypeIds: eventTypeIds })
        // }
      });
    }
    return ids;
  }

  ngOnChanges() {
    if (this.list) {

      if (this.viewBy == 'c') {       
        if (this.eventId == 'in_play') {
          this.data = (this.events.races.includes(this.eventId)) ? this.reArrangeRaceData(this.list, this.eventId) : this.listByinPlayCat(this.list);
        } else {
          this.data = (this.events.races.includes(this.eventId)) ? this.reArrangeRaceData(this.list, this.eventId) : this.listByTypeIdCat(this.list, this.eventId);
        }
      } else {        
        if (this.eventId == 'in_play') {
          this.data = (this.events.races.includes(this.eventId)) ? this.reArrangeRaceData(this.list, this.eventId) : this.listByinPlay(this.list);
        } else {
          this.data = (this.events.races.includes(this.eventId)) ? this.reArrangeRaceData(this.list, this.eventId) : this.listByTypeId(this.list, this.eventId);
        }
      }

      if (this.eventId == 'in_play') {
        this.datalength = (this.events.races.includes(this.eventId)) ? this.reArrangeRaceData(this.list, this.eventId) : this.listByinPlayData(this.list);
      } else {
        this.datalength = (this.events.races.includes(this.eventId)) ? this.reArrangeRaceData(this.list, this.eventId) : this.listByTypeIdData(this.list, this.eventId);
      }

      this.odds = this.oddsData;
      this.eId = this.eventId;

      //console.log(this.data);
      

    }

  }

}
